// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { EntityTypeId } from '../tbs/entity-type-id.js';


export class RestrictedUnitRule implements flatbuffers.IUnpackableObject<RestrictedUnitRuleT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):RestrictedUnitRule {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsRestrictedUnitRule(bb:flatbuffers.ByteBuffer, obj?:RestrictedUnitRule):RestrictedUnitRule {
  return (obj || new RestrictedUnitRule()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsRestrictedUnitRule(bb:flatbuffers.ByteBuffer, obj?:RestrictedUnitRule):RestrictedUnitRule {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new RestrictedUnitRule()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

etypeId():EntityTypeId {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : EntityTypeId.Infantry;
}

playerId():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
}

limit():number {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
}

turn():number {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
}

static startRestrictedUnitRule(builder:flatbuffers.Builder) {
  builder.startObject(4);
}

static addEtypeId(builder:flatbuffers.Builder, etypeId:EntityTypeId) {
  builder.addFieldInt16(0, etypeId, EntityTypeId.Infantry);
}

static addPlayerId(builder:flatbuffers.Builder, playerId:number) {
  builder.addFieldInt32(1, playerId, -1);
}

static addLimit(builder:flatbuffers.Builder, limit:number) {
  builder.addFieldInt32(2, limit, -1);
}

static addTurn(builder:flatbuffers.Builder, turn:number) {
  builder.addFieldInt32(3, turn, -1);
}

static endRestrictedUnitRule(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createRestrictedUnitRule(builder:flatbuffers.Builder, etypeId:EntityTypeId, playerId:number, limit:number, turn:number):flatbuffers.Offset {
  RestrictedUnitRule.startRestrictedUnitRule(builder);
  RestrictedUnitRule.addEtypeId(builder, etypeId);
  RestrictedUnitRule.addPlayerId(builder, playerId);
  RestrictedUnitRule.addLimit(builder, limit);
  RestrictedUnitRule.addTurn(builder, turn);
  return RestrictedUnitRule.endRestrictedUnitRule(builder);
}

unpack(): RestrictedUnitRuleT {
  return new RestrictedUnitRuleT(
    this.etypeId(),
    this.playerId(),
    this.limit(),
    this.turn()
  );
}


unpackTo(_o: RestrictedUnitRuleT): void {
  _o.etypeId = this.etypeId();
  _o.playerId = this.playerId();
  _o.limit = this.limit();
  _o.turn = this.turn();
}
}

export class RestrictedUnitRuleT implements flatbuffers.IGeneratedObject {
constructor(
  public etypeId: EntityTypeId = EntityTypeId.Infantry,
  public playerId: number = -1,
  public limit: number = -1,
  public turn: number = -1
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return RestrictedUnitRule.createRestrictedUnitRule(builder,
    this.etypeId,
    this.playerId,
    this.limit,
    this.turn
  );
}
}
